import React from 'react';
import PublicPageShell from './PublicPageShell';

export default function AboutScreen() {
  return (
    <PublicPageShell title="About Grove — Family Ops Hub">
      <p>
        <strong>Grove — Family Ops Hub</strong> (Grove, for short) is a
        private family logistics app. It brings a household's calendars,
        caregivers, and day-to-day details into one calm place, so the
        people who help run a family — parents, grandparents, and
        babysitters — can all see what's happening without a chain of
        texts.
      </p>
      <p>
        The name reflects what it does: it's an operations hub for a
        family's day-to-day logistics — schedules, caregiver coverage, and
        the household reference info everyone eventually needs at 7am on a
        school morning.
      </p>

      <h2>What Grove — Family Ops Hub does</h2>
      <ul>
        <li>
          <strong>Schedule, at a glance.</strong> After a household signs in
          with Google, Grove reads that family's connected Google Calendars
          and builds a shared view of who is doing pickup, drop-off, and
          care coverage on any given day — no more cross-referencing three
          separate calendars.
        </li>
        <li>
          <strong>Caregiver access, without oversharing.</strong> Account
          owners can invite a sitter or grandparent by email, or share a
          private link, giving each person only the schedule, kid, house,
          or emergency information they actually need — nothing more.
        </li>
        <li>
          <strong>Household reference in one spot.</strong> House rules,
          emergency contacts, and kid-specific notes live in Grove instead
          of a sticky note on the fridge, so anyone covering care has what
          they need without a phone call.
        </li>
      </ul>

      <h2>Who it's for</h2>
      <p>
        Grove — Family Ops Hub is built for families coordinating childcare
        across multiple adults. A household signs in with Google, connects
        the calendars that matter, and invites the caregivers who need
        visibility into the schedule and household details.
      </p>

      <h2>How it's run</h2>
      <p>
        Grove — Family Ops Hub is a small, independently operated app
        hosted on Firebase at <strong>grove.mcschaef.family</strong>. It is
        not affiliated with Google, does not run advertising, and does not
        sell user data. See our <a href="/privacy">Privacy Policy</a> and{' '}
        <a href="/terms">Terms of Service</a> for details on how account and
        family data is handled.
      </p>
    </PublicPageShell>
  );
}
